import React from 'react';
import { useIntl } from 'react-intl';
import { Layer, Loading, Pane, PaneFooter, Paneset } from '@folio/stripes/components';
import { CancelEditModal, ListAppIcon, Buttons } from '../../../../components';
import { t, tString } from '../../../../services';
export var CreateListLayout = function (_a) {
    var _b = _a.isSaveButtonDisabled, isSaveButtonDisabled = _b === void 0 ? false : _b, _c = _a.isSavingInProgress, isSavingInProgress = _c === void 0 ? false : _c, _d = _a.onSave, onSave = _d === void 0 ? function () { } : _d, _e = _a.onClose, onClose = _e === void 0 ? function () { } : _e, _f = _a.showModalOnCancel, showModalOnCancel = _f === void 0 ? false : _f, children = _a.children, _g = _a.showConfirmCancelEditModal, showConfirmCancelEditModal = _g === void 0 ? false : _g, keepEditHandler = _a.keepEditHandler, setShowConfirmCancelEditModal = _a.setShowConfirmCancelEditModal, continueNavigation = _a.continueNavigation, onCancel = _a.onCancel;
    var intl = useIntl();
    var cancelHandler = function () {
        if (!showConfirmCancelEditModal) {
            setShowConfirmCancelEditModal(true);
        }
        continueNavigation();
    };
    return (React.createElement(Paneset, null,
        React.createElement(Layer, { isOpen: true, contentLabel: tString(intl, 'create-list.title') },
            React.createElement(Paneset, { isRoot: true },
                React.createElement(Pane, { dismissible: true, defaultWidth: "fill", onClose: onClose, appIcon: React.createElement(ListAppIcon, null), paneTitle: t('create-list.title'), paneSub: !isSavingInProgress ? (t('create-list.subtitle')) : (React.createElement(React.Fragment, null,
                        t('create-list.saving'),
                        " ",
                        React.createElement(Loading, null))), footer: React.createElement(PaneFooter, { renderStart: React.createElement(Buttons.Cancel, { onCancel: function () {
                                onCancel();
                                cancelHandler();
                            } }), renderEnd: React.createElement(Buttons.Save, { disabled: isSaveButtonDisabled || isSavingInProgress, onSave: onSave }) }) },
                    children,
                    React.createElement(CancelEditModal, { onCancel: function () {
                            cancelHandler();
                            setShowConfirmCancelEditModal(false);
                        }, onKeepEdit: keepEditHandler, open: showModalOnCancel && showConfirmCancelEditModal }))))));
};
